<template>
  <div class="mt-component-form print-container mb-4">
    <vs-row class="my-4 center-flex">
      <h5><i class="dot"></i>{{ title }}</h5>
      <div class="ml-auto">
        <vs-button v-if="!isPrint" color="secondary" type="border" @click="handleRemoveRow">선택삭제</vs-button>
        <vs-button v-if="!isPrint" class="ml-4" color="secondary" @click="handleAddRow">취급부서 추가</vs-button>
      </div>
    </vs-row>

    <div class="w-full" style="overflow-x: auto">
      <table>
        <colgroup>
          <col v-if="!isPrint" width="50" />
          <col />
          <col />
          <col />
        </colgroup>
        <thead>
          <tr>
            <th v-if="!isPrint">
              <vs-checkbox v-model="tableAllCheck" class="custom-checkbox"></vs-checkbox>
            </th>
            <th>사업장</th>
            <th>공장명</th>
            <th>공정명</th>
          </tr>
        </thead>
        <tbody is="draggable" :list="tableList" tag="tbody" handle=".handle">
          <tr v-for="(row, index) in tableList" :key="index">
            <td v-if="!isPrint">
              <div class="flex items-center justify-center">
                <feather-icon class="handle" icon="MenuIcon" style="width: 14px; height: 14px; cursor: pointer" />
                <vs-checkbox v-model="row.is_checked" class="custom-checkbox"></vs-checkbox>
              </div>
            </td>
            <td>
              <CustomOptionSelector class="w-full" :isPrint="isPrint" :readonly="isReadonly" :options="사업장옵션" v-model="row.사업장" @input="onChangeField(row)" />
            </td>
            <td>
              <CustomOptionSelector class="w-full" :isPrint="isPrint" :readonly="isReadonly || !row.사업장" :options="getFactoryOptions(row.사업장)" v-model="row.공장명" @input="onChangeFactory(row)" />
            </td>
            <td>
              <CustomOptionSelector class="w-full" :isPrint="isPrint" :readonly="isReadonly || !row.공장명" :options="getProcessOptions(row.사업장, row.공장명)" v-model="row.공정명" />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import CustomOptionSelector from "@/components/selector/CustomOptionSelector.vue";
import { 당진공장, 인천공장, 포항공장 } from "./options";

const 사업장별공장목록 = { 당진공장, 인천공장, 포항공장 };

export default {
  name: "HandlingDeptTable",
  components: {
    draggable,
    CustomOptionSelector,
  },
  props: {
    title: {
      type: String,
      default: () => "취급 부서",
    },
    value: Array,
    isPrint: Boolean,
    isReadonly: Boolean,
  },
  data() {
    return {
      tableList: this.value,
    };
  },
  computed: {
    사업장옵션() {
      return Object.keys(사업장별공장목록);
    },
    tableAllCheck: {
      get() {
        if (this.tableList.length > 0) {
          return this.tableList.every((data) => data.is_checked);
        }
        return false;
      },
      set(value) {
        for (const data of this.tableList) {
          data.is_checked = value;
        }
      },
    },
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        if (value && value.length > 0) {
          this.tableList = value;
        }
      },
    },
    tableList: {
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    getFactoryOptions(사업장) {
      if (!사업장 || !사업장별공장목록[사업장]) return [];
      return Object.keys(사업장별공장목록[사업장]);
    },
    getProcessOptions(사업장, 공장명) {
      if (!사업장 || !공장명 || !사업장별공장목록[사업장]) return [];
      return 사업장별공장목록[사업장][공장명] || [];
    },
    onChangeField(row) {
      row.공장명 = "";
      row.공정명 = "";
    },
    onChangeFactory(row) {
      row.공정명 = "";
    },
    handleAddRow() {
      this.tableList.push({
        is_checked: false,
        사업장: "",
        공장명: "",
        공정명: "",
      });
    },
    handleRemoveRow() {
      for (let i = 0; i < this.tableList.length; i++) {
        if (this.tableList[i].is_checked) {
          this.tableList.splice(i, 1);
          i = -1;
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
.custom-checkbox::v-deep {
  justify-content: center !important;
  .vs-checkbox {
    margin: 0 !important;
  }
}

table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;

  th {
    font-weight: 700;
    font-size: 14px;
    text-align: center;

    background-color: #f9f9f9;
    border: 1px solid #cdcdcd;

    padding: 12px 0;
  }

  td {
    font-weight: 400;
    font-size: 14px;
    text-align: center;

    border: 1px solid #cdcdcd;
    padding: 6px;
  }
}
</style>
